"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OneSatApis = void 0;
const scrypt_ts_1 = require("scrypt-ts");
const superagent_1 = __importDefault(require("superagent"));
const utils_1 = require("./utils");
class OneSatApis {
    static apiBase(network) {
        return network === scrypt_ts_1.bsv.Networks.mainnet
            ? 'https://ordinals.gorillapool.io/api'
            : 'https://testnet.ordinals.gorillapool.io/api';
    }
    static fetchUTXOByOutpoint(outpoint, network) {
        const url = `${this.apiBase(network || scrypt_ts_1.bsv.Networks.mainnet)}/txos/${outpoint}?script=true`;
        return superagent_1.default
            .get(url)
            .then(function (response) {
            // handle success
            const script = Buffer.from(response.body.script, 'base64').toString('hex');
            return {
                txId: response.body.txid,
                outputIndex: response.body.vout,
                satoshis: 1,
                script,
            };
        })
            .catch(function (error) {
            // handle error
            (0, utils_1.handlerApiError)(error);
            return null;
        });
    }
    static async fetchLatestByOrigin(origin, network) {
        const url = `${this.apiBase(network || scrypt_ts_1.bsv.Networks.mainnet)}/inscriptions/${origin}/latest?script=true`;
        const res = await superagent_1.default
            .get(url)
            .then(function (response) {
            // handle success
            return response.body;
        })
            .catch(function (error) {
            // handle error
            (0, utils_1.handlerApiError)(error);
            return null;
        });
        if (!res) {
            return null;
        }
        const { spend, txid, vout, script } = res;
        if (spend) {
            return null;
        }
        return {
            txId: txid,
            outputIndex: vout,
            satoshis: 1,
            script: Buffer.from(script, 'base64').toString('hex'),
        };
    }
    static fetchBSV20Utxos(address, tick) {
        const network = scrypt_ts_1.bsv.Address.fromString(address).network;
        const url = (0, utils_1.isBSV20v2)(tick)
            ? `${this.apiBase(network || scrypt_ts_1.bsv.Networks.mainnet)}/bsv20/${address}/id/${tick}`
            : `${this.apiBase(network || scrypt_ts_1.bsv.Networks.mainnet)}/bsv20/${address}/tick/${tick}`;
        return superagent_1.default
            .get(url)
            .then(async function (response) {
            // handle success
            if (Array.isArray(response.body)) {
                const utxos = await Promise.all(response.body.map((utxo) => {
                    return OneSatApis.fetchUTXOByOutpoint(utxo.outpoint, network);
                }));
                return utxos.filter((u) => u !== null);
            }
            return [];
        })
            .catch(function (error) {
            (0, utils_1.handlerApiError)(error);
            return [];
        });
    }
    static postTx(rawtx, network) {
        const url = `${this.apiBase(network || scrypt_ts_1.bsv.Networks.mainnet)}/tx`;
        return superagent_1.default
            .post(url)
            .send({
            rawtx: Buffer.from(rawtx, 'hex').toString('base64'),
        })
            .then(function (response) {
            // handle success
            if (response.status !== 200) {
                throw new Error(`invalid status: ${response.status}`);
            }
            return response.body;
        })
            .catch(function (error) {
            (0, utils_1.handlerApiError)(error);
            return;
        });
    }
    static submitTx(txid, network) {
        const url = `${this.apiBase(network || scrypt_ts_1.bsv.Networks.mainnet)}/tx/${txid}/submit`;
        return superagent_1.default
            .post(url)
            .then(function (response) {
            // handle success
            if (response.status !== 204) {
                throw new Error(`invalid status: ${response.status}`);
            }
            return;
        })
            .catch(function (error) {
            (0, utils_1.handlerApiError)(error);
            return;
        });
    }
}
exports.OneSatApis = OneSatApis;
